module.exports = __webpack_public_path__ + "1bc357fb1d319d8bc4ac777fd9a77a4b.svg";